import React from 'react'
import AppImages from '../../Utils/ThemeImages'

const OurTeam = () => {
  return (
    <section className="home-section-8">
        <div className="inner-home-section-8">
            <div className="container">
                <div className="top-home-sec-8-heading-part">
                    <div className="left-head-sec-8-home wow animate__animated animate__fadeInDown">
                        <h2>Meet Our Team</h2>
                    </div>
                </div>
                <div className="swiper-home-section-6-blk new-our-team-section-block">
                    <div className="grid grid-cols-2 gap-16 new-ourteam-gird-section">
                        <div className="single-our-team-section-home wow animate__animated animate__fadeInLeft">
                            <div className="our-team-image-section relative overflow-hidden group">
                                <img src={AppImages.chairmanImage} alt="" className='w-full h-full max-h-[480px] object-cover object-top border border-black border-opacity-10'/>
                                <div className="absolute-team-social-section bg-black bg-opacity-60 -bottom-[150px] group-hover:bottom-0 absolute flex items-center left-0 w-full px-10 h-[150px]">
                                    <div className="name-section flex flex-col gap-2">
                                        <h4 className='font-semibold text-white text-3xl'>MR.SAUD AL BALUSHI</h4>
                                        <p className='text-white text-lg font-medium'>Chairman of White Tower</p>
                                    </div>
                                    {/* <div className="inner-team-social-blocks-sectioon pt-6 pb-10">
                                        <div className="single-social-our-team-sec flex items-center gap-10">
                                            <div className="single-social-link-footer">
                                                <button type='button' className=''>
                                                    <i className="bi bi-instagram text-lg duration-500"></i>
                                                </button>
                                            </div>
                                            <div className="single-social-link-footer">
                                            <button type='button' className=''>
                                                <i className="bi bi-twitter-x text-lg duration-500"></i>
                                            </button>
                                            </div>
                                            <div className="single-social-link-footer">
                                            <button type='button' className=''>
                                                <i className="bi bi-facebook text-lg duration-500"></i>
                                            </button>
                                            </div>
                                            <div className="single-social-link-footer">
                                            <button type='button' className=''>
                                                <i className="bi bi-whatsapp text-lg duration-500"></i>
                                            </button>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                        <div className="single-our-team-section-home wow animate__animated animate__fadeInRight">
                            <div className="our-team-image-section relative overflow-hidden group">
                                <img src={AppImages.ceoImage} alt="" className='w-full h-full max-h-[480px] object-cover object-top border border-black border-opacity-10'/>
                                <div className="absolute-team-social-section bg-black bg-opacity-60 -bottom-[150px] group-hover:bottom-0 absolute flex items-center left-0 w-full px-10 h-[150px]">
                                    <div className="name-section flex flex-col gap-2">
                                        <h4 className='font-semibold text-white text-3xl'>MR.NEELESH KAMUJU</h4>
                                        <p className='text-white text-lg font-medium'>CEO of White Tower</p>
                                    </div>
                                    {/* <div className="inner-team-social-blocks-sectioon pt-6 pb-10">
                                        <div className="single-social-our-team-sec flex items-center gap-10">
                                            <div className="single-social-link-footer">
                                                <button type='button' className=''>
                                                    <i className="bi bi-instagram text-lg duration-500"></i>
                                                </button>
                                            </div>
                                            <div className="single-social-link-footer">
                                            <button type='button' className=''>
                                                <i className="bi bi-twitter-x text-lg duration-500"></i>
                                            </button>
                                            </div>
                                            <div className="single-social-link-footer">
                                            <button type='button' className=''>
                                                <i className="bi bi-facebook text-lg duration-500"></i>
                                            </button>
                                            </div>
                                            <div className="single-social-link-footer">
                                            <button type='button' className=''>
                                                <i className="bi bi-whatsapp text-lg duration-500"></i>
                                            </button>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
  )
}

export default OurTeam